import React from "react";
import { Route, Switch } from "react-router";

import appUrls from "../config/appUrls";

import LoggedInWrapper from "./LoggedInWrapper";
import Home from "../screens/Home";
import Channel from "../screens/Channel";
import KPIs from "../screens/KPIs";
import EntityZoomed from "../screens/EntityZoomed";
import SectorZoomed from "../screens/SectorZoomed";
import ChannelZoomed from "../screens/ChannelZoomed";
import Services from "../screens/Services";
import ServiceCenters from "../screens/ServiceCenters";
import Login from "../screens/Login";

const AppRoutes = () => {
  return (
    <Switch>
      <Route exact path={appUrls.LOGIN} component={Login} />
      <Route exact path="/" component={Login} />
      <Switch>
        <LoggedInWrapper>
          <Route exact path={appUrls.HOME} component={Home} />
          <Route exact path={appUrls.KPIS} component={KPIs} />
          <Route exact path={appUrls.CHANNEL} component={Channel} />
          <Route exact path={appUrls.SERVICES} component={Services} />
          <Route
            exact
            path={appUrls.SERVICE_CENTERS}
            component={ServiceCenters}
          />
          <Route exact path={appUrls.ENTITY_ZOOMED} component={EntityZoomed} />
          <Route exact path={appUrls.SECTOR_ZOOMED} component={SectorZoomed} />
          <Route
            exact
            path={appUrls.CHANNEL_ZOOMED}
            component={ChannelZoomed}
          />
        </LoggedInWrapper>
      </Switch>
    </Switch>
  );
};

export default AppRoutes;
